import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import FontIcon from 'components/FontIcon';
import SearchButtonA from 'components/SearchButton/SearchButtonA';
import classes from './SiteNavAMobileLevelA.module.scss';

const SiteNavAMobileLevelA = (props) => {
  const {
    imageUrl,
    imageLinkHref,
    imageLinkTarget,
    imageAltText,
    contactHref,
    onHamburgerClick,
    searchResultsLinkHref,
    siteId,
    itemsCount,
    cartUrl,
  } = props;

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <Link
          href={imageLinkHref}
          target={imageLinkTarget}
          className={classes.logo}
        >
          <img
            src={imageUrl}
            alt={imageAltText}
            height={26}
            width={132}
          />
        </Link>
        <div className={classes.rightNav}>
          <Link
            href={cartUrl}
            className={classes.icon}
          >
            <FontIcon icon='far fa-shopping-cart' className={classes.iconCart}>
              {itemsCount > 0 ? <span className={classes.badge}>{itemsCount}</span> : null}
            </FontIcon>
          </Link>

          {contactHref && (
            <Link
              href={contactHref}
              className={classes.icon}
            >
              <FontIcon icon='far fa-phone' className={classes.iconPhone} />
            </Link>
          )}

          <SearchButtonA
            siteSearch360SiteId={siteId}
            siteSearch360SiteResults={searchResultsLinkHref}
            searchQueryString='search'
          />

          <button aria-label='Menu' className={classes.icon} onClick={onHamburgerClick} type='button'>
            <FontIcon icon='far fa-bars' className={classes.iconHamburger} />
          </button>
        </div>
      </div>
    </div>
  );
};

SiteNavAMobileLevelA.propTypes = {
  imageUrl: PropTypes.string,
  imageLinkHref: PropTypes.string,
  imageLinkTarget: PropTypes.string,
  imageAltText: PropTypes.string,
  contactHref: PropTypes.string,
  onHamburgerClick: PropTypes.func.isRequired,
  searchResultsLinkHref: PropTypes.string,
  siteId: PropTypes.string,
  itemsCount: PropTypes.number,
  cartUrl: PropTypes.string,
};

export default SiteNavAMobileLevelA;
